import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { siteHit } from "../lib/api";

const PUBLIC = ["/", "/tour", "/trust", "/privacy", "/terms", "/welcome", "/learn", "/blog", "/faq", "/compare", "/switch", "/for-advisors", "/advisor/login"];
const isPublic = (p) => p === "/" || PUBLIC.some((x) => x !== "/" && p.startsWith(x));

// First-party, cookie-less page views for public pages only. Honours Do-Not-Track / Global Privacy Control.
export const usePageview = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (typeof window === "undefined" || !isPublic(pathname)) return;
    if (navigator.doNotTrack === "1" || window.doNotTrack === "1" || navigator.globalPrivacyControl) return;
    const q = new URLSearchParams(search);
    // Blog nudge arrivals are tracked as a sub-path so Admin traffic shows which post sent them.
    const path = pathname === "/welcome" && q.get("src") === "blog" ? `/welcome/from-blog/${(q.get("post") || "post").replace(/[^a-z0-9-]/gi, "")}` : pathname;
    siteHit(path, document.referrer || "");
  }, [pathname, search]);
};
